import PropTypes from 'prop-types';
import React from 'react';

import { ENUM_MODULE_NAME } from '../../../commons/utils/features';

import { CENTRAL_KITCHEN_STOCKS_FEATURE_PATHS } from '../../../commons/utils/featurePaths';

import { ModuleContainer } from '../../ModuleContainer';

export const StocksCentralKitchenAnalyticsPastContainer = (props) => {
  const { userRights, history } = props;

  return (
    <ModuleContainer
      history={history}
      moduleFeaturePaths={[
        CENTRAL_KITCHEN_STOCKS_FEATURE_PATHS.STOCKS_CENTRAL_KITCHEN_ANALYTICS_PAST_RECIPES,
        CENTRAL_KITCHEN_STOCKS_FEATURE_PATHS.STOCKS_CENTRAL_KITCHEN_ANALYTICS_PAST_INGREDIENTS,
      ]}
      moduleName={ENUM_MODULE_NAME.CENTRAL_KITCHEN_STOCKS}
      userRights={userRights}
    />
  );
};

StocksCentralKitchenAnalyticsPastContainer.propTypes = {
  userRights: PropTypes.array,
  history: PropTypes.any, // react-router-dom's route prop
  moduleName: PropTypes.oneOf(Object.values(ENUM_MODULE_NAME)),
  moduleFeaturePaths: PropTypes.arrayOf(PropTypes.string),
};

import StocksCentralKitchenAnalyticsPastIngredients from './StocksCentralKitchenAnalyticsPastIngredients';
import StocksCentralKitchenAnalyticsPastRecipes from './StocksCentralKitchenAnalyticsPastRecipes';

const StocksCentralKitchenAnalyticsPastModule = {
  StocksCentralKitchenAnalyticsPastContainer,
  StocksCentralKitchenAnalyticsPastRecipes,
  StocksCentralKitchenAnalyticsPastIngredients,
};

export default StocksCentralKitchenAnalyticsPastModule;
